import { getPlotBoundsRelativeToOverlay } from 'features/timeSeries/components/rulerTool/useRulerTool'
import React from 'react'
import uPlot from 'uplot'

/** Below this a drag reads as a click, not a region. */
export const MIN_DRAW_WIDTH_PX = 5

/** Overlay mouse event -> chart-time ms + clamped overlay-x. One projection
    for every drag-a-range overlay (labels, split windows). */
export const overlayPosToMs = (
  u: uPlot | null,
  e: React.MouseEvent<HTMLDivElement>
): { valueMs: number; pixelX: number } | null => {
  if (!u) return null
  const overlayEl = e.currentTarget
  const { overLeft, overRight } = getPlotBoundsRelativeToOverlay(overlayEl, u)
  const mouseXOnOverlay = e.clientX - overlayEl.getBoundingClientRect().left
  const clampedX = Math.max(overLeft, Math.min(overRight, mouseXOnOverlay))
  const valueMs = u.posToVal(clampedX - overLeft, 'x')
  if (!Number.isFinite(valueMs)) return null
  return { valueMs, pixelX: clampedX }
}
